import React, { memo } from 'react';
import {
  Stack,
  NavFooter,
  withWindowSize,
  util,
  Detail,
  Box,
} from '@thecb/components';
import footerLogo from '../../static/img/euna-logo.svg';
import { fallbackValues } from './Footer.theme';
import { useFlags } from 'launchdarkly-react-client-sdk';

const {
  theme: { themeComponent },
} = util;

const Footer = ({ themeValues = {} }) => {
  const flags = useFlags();
  const footerRightContent = (
    <Box padding="0">
      <Detail
        as="p"
        size="1rem"
        color={themeValues.linkColor}
        title={flags['pay-with-device-payment-service'] ? 'DPS' : ''}
      >
        Cashiering
      </Detail>
    </Box>
  );

  const footerLeftContent = (
    <Stack justify="center">
      <img src={footerLogo} width="70px" height="28px" alt="Euna Solutions" />
    </Stack>
  );

  return (
    <Stack childGap="0">
      <NavFooter
        key="main-footer"
        leftContent={footerLeftContent}
        rightContent={footerRightContent}
        backgroundColor={themeValues.backgroundColor}
        role="contentinfo"
        aria-label="footer"
      />
    </Stack>
  );
};

export default withWindowSize(
  memo(themeComponent(Footer, 'Footer', fallbackValues)),
);
